export default __webpack_public_path__ + "cc44433db7c6e52cf65e00d9270e0387.png";